/*
 * Copyright (c) 2026, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    publicFooter: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      padding: theme.spacing(3),
      boxSizing: 'border-box',
      // A band rather than open page, so the marketing section above it reads
      // as having ended rather than as having run out.
      backgroundColor: theme.palette.grey[100],
      borderTop: `1px solid ${theme.palette.divider}`,
      textAlign: 'center',
    },
    policyLinks: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  })
);
